module.exports = __webpack_public_path__ + "static/img/service-apply.ee5a3386.png";